import React from 'react';

const InfinitySVG = ({
  className = '',
  color = '#8940FA',
  width = 22,
  height = 25,
}) => (
  <svg width={width} height={height} viewBox="0 0 20 20" className={className}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(2.000000, 7.000000)"
        fill={color}
        fillRule="nonzero"
        stroke={color}
        strokeWidth="0.8"
      >
        <path d="M12.80432,0.00045 C10.12,0.00045 7.49056,2.53995 7.48848,2.54175 C7.22496,2.7693 5.12,4.71225 3.19456,4.71225 C2.2,4.71225 1.39136,3.94425 1.39136,2.99985 C1.39136,2.0559 2.2008,1.2879 3.19536,1.2879 C4.28864,1.2879 5.34496,1.86255 6.04032,2.31885 C6.04096,2.31915 6.0424,2.3184 6.0432,2.3187 C6.1552,2.39415 6.29152,2.4399 6.44,2.4399 C6.81648,2.4399 7.1216,2.15415 7.1216,1.80165 C7.1216,1.5834 7.00432,1.39125 6.82592,1.2762 C6.8256,1.2759 6.8256,1.27545 6.82512,1.27515 C6.824,1.2744 6.82288,1.2738 6.82176,1.27305 C6.82128,1.27275 6.82064,1.27245 6.82016,1.272 C5.73984,0.5733 4.50288,0 3.19568,0 C1.43056,0 0,1.3431 0,2.9979 C0,4.65255 1.43056,5.9994 3.19568,5.9994 C5.86,5.9994 8.50944,3.4599 8.51152,3.45825 C8.77504,3.23055 10.88,1.28745 12.80544,1.28745 C13.8,1.28745 14.60864,2.05575 14.60864,3 C14.60864,3.94395 13.7992,4.71195 12.80464,4.71195 C11.71136,4.71195 10.65504,4.1373 9.95968,3.68115 C9.95904,3.68055 9.9576,3.68145 9.9568,3.68115 C9.8448,3.6057 9.70848,3.55995 9.56,3.55995 C9.18352,3.55995 8.8784,3.84585 8.8784,4.1982 C8.8784,4.41645 8.99568,4.6086 9.17408,4.72365 C9.1744,4.72395 9.1744,4.72455 9.17488,4.72485 C9.176,4.72545 9.17712,4.72605 9.17824,4.72695 C9.17872,4.72725 9.17936,4.72755 9.17984,4.72785 C10.26016,5.42685 11.49712,6 12.80432,6 C14.56944,6 16,4.65705 16,3.00195 C16,1.34715 14.56944,0.00045 12.80432,0.00045 Z" />
      </g>
    </g>
  </svg>
);

export default InfinitySVG;
